import { Injector } from '@angular/core';

/**
 * Custom injector
 * @template T
 */
export class CustomInjector<T> {
    /**
     * Gets custom injector
     * @param service
     * @returns get
     */
    get(service: any): T {
        const injector: any = Injector.create({ providers: [{ provide: service, deps: [] }] });
        return injector.get(service);
    }
}
